/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SessionExpired/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SessionExpired({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/SessionExpired"
  
}) {
  return null
}